(function () {
  function openFacets() {
    if (window.innerWidth < 750) return;
    document.querySelectorAll('details.facets__disclosure-vertical').forEach(function (d) { if (!d.dataset.coloSeen) { d.dataset.coloSeen = '1'; d.open = true; } });
  }
  function decoratePrice() {
    document.querySelectorAll('.facets__price').forEach(function (p) {
      if (p.dataset.coloPrice) return;
      var ins = p.querySelectorAll('input.field__input');
      if (ins.length < 2) return;
      p.dataset.coloPrice = '1';
      ins[0].placeholder = 'Min $';
      ins[1].placeholder = 'Max $';
      ins[0].setAttribute('aria-label', 'Minimum price');
      ins[1].setAttribute('aria-label', 'Maximum price');
      var go = false;
      function block(e) { if (!go) e.stopPropagation(); }
      ins.forEach(function (i) {
        ['input', 'change', 'focusout'].forEach(function (t) { i.addEventListener(t, block, true); });
        i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
      });
      function apply() {
        go = true;
        ins[1].dispatchEvent(new Event('input', { bubbles: true }));
        ins[1].dispatchEvent(new Event('change', { bubbles: true }));
        go = false;
      }
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'colo-price-go'; b.textContent = 'Apply';
      b.addEventListener('click', apply);
      p.appendChild(b);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { openFacets(); decoratePrice(); });
  var mo = new MutationObserver(function () { openFacets(); decoratePrice(); });
  document.addEventListener('DOMContentLoaded', function () { mo.observe(document.body, { childList: true, subtree: true }); });
  document.addEventListener('click', function (e) {
    var rb = e.target.closest('.colo-rail__btn');
    if (rb) {
      var track = rb.parentElement.querySelector('.colo-rail__track');
      track.scrollBy({ left: parseInt(rb.dataset.dir, 10) * track.clientWidth * 0.85, behavior: 'smooth' });
      return;
    }
    var add = e.target.closest('[data-colo-add]');
    if (!add || add.disabled) return;
    add.disabled = true;
    var label = add.textContent;
    add.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(add.dataset.variant), quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && state.sections) {
          drawer.renderContents(state);
          add.textContent = 'Added ✓';
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () {
        setTimeout(function () { add.disabled = false; add.textContent = label; }, 1800);
      });
  });
})();
